<template>
  <div class="box">
    <div class="header">
      <div class="logo">
        <img src="../../assets/images/logo.png" alt />
      </div>
      <div class="btn-box">
        <div>
          <span  @click="go('login')">已有账号，去登录</span>
        </div>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      statues: 2
    };
  },
  components: {},
  methods: {
    go(type) {
      this.$router.push({ name: type });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  height: 200px;
   background: url("../../assets/images/black.jpg") 0 0;
  .logo {
    padding-top: 50px;
    img {
      display: block;
      width: 70px;
      height: 70px;
      margin: 0 auto;
    }
  }
}
.content {
  padding: 36px 30px;
}
.login-box {
  position: fixed;
  font-size: 14px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  span {
    color: #228ccd;
  }
}

.btn-box{ text-align: center; margin-top: 26px; color: #fff; font-size: 16px; }
</style>
